// These schemas should match their corresponding DB model in @performyard/models
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskBase () {
        return AutoflowTaskBase;
    },
    get AutoflowTaskBaseInputs () {
        return AutoflowTaskBaseInputs;
    },
    get AutoflowTaskBaseOutputs () {
        return AutoflowTaskBaseOutputs;
    },
    get AutoflowTaskBaseResponse () {
        return AutoflowTaskBaseResponse;
    }
});
const _zod = require("zod");
const AutoflowTaskBaseOutputs = _zod.z.object({});
const AutoflowTaskBaseInputs = _zod.z.record(AutoflowTaskBaseOutputs.partial().or(_zod.z.null()));
const AutoflowTaskBase = _zod.z.object({
    taskId: _zod.z.string(),
    taskType: _zod.z.string(),
    inputs: AutoflowTaskBaseInputs.optional(),
    retries: _zod.z.number().default(3)
});
const AutoflowTaskBaseResponse = AutoflowTaskBase.extend({
    error: _zod.z.string().optional(),
    outputs: _zod.z.void()
});
